export default function getTableConfigFromStorage(formName) {
  var tableConfig = window.localStorage.getItem(formName);
  tableConfig = tableConfig && JSON.parse(tableConfig);
  return tableConfig;
}